module.exports = __webpack_public_path__ + "images/background/login__background-6ab13937b6fda99d00a81d6f824c699b.svg";